export const primaryColor = '#185ADB';

export const secondaryColor = '#0A1931';

export const terciaryColor = '#C4C4C4';

export const greyColor = '#B7C2CF';

export const greyLightColor = '#E8E8E8';
